export enum AuthenticationCase {
  NoCustomer = "NoCustomer",
  NoRoles = "NoRoles",
  NoIcp = "NoIcp",
  NotAuthenticated = "NotAuthenticated",
  // SurfDomeinen = "SurfDomeinen", // TODO When implemented
  ValidUser = "ValidUser",
}
